import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { downersGroveConfig } from "./data";

export default function DownersGrovePage() {
  return <CityPageTemplate config={downersGroveConfig} />;
}